import React from 'react'
import styled, { css } from 'styled-components'

import { media } from '../../../styles/utils'
import { heading } from '../../../styles/global'
import { lightGrey } from '../../../styles/colors'

const BlockText = (props) => {
  const { title, content, articleBlock } = props

  return (
    <Wrapper articleBlock={articleBlock}>
      {title && <Title>{title}</Title>}
      <Text articleBlock={articleBlock} dangerouslySetInnerHTML={{ __html: content }} />
    </Wrapper>
  )
}

const Text = styled.div`
  &, p {
    font-size: 18px;
    color: ${lightGrey};
  }

  /* Global reset uses 1rem for h1–h3; restore design-system size for CMS HTML on dynamic pages */
  ${(props) =>
    !props.articleBlock &&
    css`
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        ${heading}
        margin: 0 0 0.5em 0;
        color: rgba(0, 0, 0, 0.8);
      }
    `}
`
const Title = styled.h2`
  font-size: 36px;
  line-height: 1.21;
  margin-bottom: 1em;

  ${media.phone`
    font-size: 32px;
  `}
`

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 2rem;

  ${media.phone`
    flex-direction: column;
  `}

  ${Title} {
    flex: 1;
    max-width: 40%;
  }

  ${Text} {
    flex: 1;
    ${media.phone`
      max-width: 100%;
    `}
  }

  strong,
  b {
    color: rgba(0, 0, 0, 0.8);
  }

  ${(props) => {
    if (!props.articleBlock)
      return css`
        ${Text} {
          /* Existing styles can be adjusted if needed */
          ${media.phone`
            flex: 1 0 100%;
          `}
        }
      `

    if (props.articleBlock)
      return css`
        ${Text} {
          font-size: 18px;
          flex: 1;

          ${media.phone`
					flex: 1 0 100%;
				`}

          &, p {
            color: ${lightGrey};
          }
        }
      `
  }}
`

BlockText.wrapper = css``

export default BlockText
